import { boolean, number, string } from "yup";
import { AddressesText } from "../../../Addresses/Addresses-types";
import { deliveryQuestionFieldName } from "../../../Addresses/addressesUtils";
/**
 * Func to provide error messages with field names (where possible).
 * @param fieldName
 * @returns String error message. E.g., "First Name field is required."
 */
export const errMsg = (fieldName) => `${fieldName} is required.`;
/**
 * Dynamically creates validation schema rules for a delivery question.
 * @param question
 * @returns yup string schema
 */
const buildDeliveryInputSchemaRules = (question) => {
    if (question.IsOptional)
        return string().notRequired();
    else
        return string().required(AddressesText.REQUIRED_QUESTION);
};
/**
 * Creates yup object schema for all questions, if applicable, to be spread into the statically defined schema.
 * @param questions
 * @returns yup object schema
 */
export const buildDeliveryInputSchema = (questions, isDeliveryOrder) => {
    //If there are no questions, we don't want them in the schema
    if (!questions)
        return {};
    //We don't show questions for delivery orders. Questions have already been answered when the address was created. 
    if (questions && isDeliveryOrder)
        return {};
    return Object.fromEntries(questions.map((q) => [deliveryQuestionFieldName(q), buildDeliveryInputSchemaRules(q)]));
};
/**
 * Static schema definition.
 * @note The delivery questions schema is created and added in the address form component.
 */
export const addressFormSchema = {
    // Required inputs
    address1: string().required(errMsg(AddressesText.ADDRESS)),
    city: string().required(errMsg(AddressesText.CITY)),
    firstName: string().required(errMsg(AddressesText.FIRST_NAME)),
    lastName: string().required(errMsg(AddressesText.LAST_NAME)),
    zip: string().required(errMsg(AddressesText.POSTAL_CODE)),
    state: string().required(errMsg(AddressesText.STATE_PROVINCE)),
    // Optional inputs
    address2: string().notRequired(),
    isPrimary: boolean().notRequired(),
    // Hidden values
    addressId: number().notRequired(),
    country: string().notRequired(),
};
